var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44823 27.2228C2.70779 27.2228 2.07753 26.9627 1.55746 26.4427C1.03738 25.9226 0.777344 25.2929 0.777344 24.5535V3.44756C0.777344 2.70932 1.03738 2.07961 1.55746 1.55843C2.07753 1.03836 2.70779 0.77832 3.44823 0.77832H24.5526C25.2908 0.77832 25.9205 1.03836 26.4417 1.55843C26.9617 2.07851 27.2218 2.70876 27.2218 3.44921V24.5535C27.2218 25.2918 26.9617 25.9215 26.4417 26.4427C25.9216 26.9627 25.2919 27.2228 24.5526 27.2228H3.44823ZM11.5204 25.57V14.8269H2.43012V24.5535C2.43012 24.8499 2.52543 25.0934 2.71605 25.2841C2.90667 25.4747 3.15073 25.57 3.44823 25.57H11.5204ZM13.1732 25.57H24.5526C24.8489 25.57 25.0925 25.4747 25.2831 25.2841C25.4737 25.0934 25.569 24.8499 25.569 24.5535V14.8269H13.1732V25.57ZM2.43012 13.1742H25.569V3.44921C25.569 3.15171 25.4737 2.90765 25.2831 2.71703C25.0925 2.52641 24.8489 2.4311 24.5526 2.4311H3.44658C3.15018 2.4311 2.90667 2.52641 2.71605 2.71703C2.52543 2.90765 2.43012 3.15171 2.43012 3.44921V13.1742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f728f413c2417f599ad66b51b66cf627.svg";
export { ForwardRef as ReactComponent };